<!-- <img src="../../../../assets/images/spinner.gif" style="height:200px;width:200px;display: block;margin:auto;" *ngIf="this.showLoading"/> -->

<div *ngIf="!(this.showLoading)">
  <div class="mt-1">
    <div class="row" style="margin-left: 10px;margin-right:10px">
      <div class="d-flex col-md-6">
        <img src="../../../../assets/images/goBack.png" (click)="goBack()" style="width:16px;height: 16px;margin-top: 8px;cursor:pointer;"/>&nbsp;&nbsp;&nbsp;<h1>{{this.viewData.type}} registration</h1>
      </div>
      <div class="col-md-5 d-flex justify-content-end" style="position:absolute;right:0px;">
          <!-- Created Screen Button -->
          <!-- <button class="button" type="button" style="background-color: #fff;color:#007CB0;border:1px solid #007CB0;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Created">
            Resend Mail &nbsp; <img src="../../../../assets/images/blueEmail.png" style="margin-bottom: 2px;"/>
          </button> -->
          <button class="button blue" (click)="CheckMaterials()" type="button" style="background-color: #007CB0;border-width: 0px;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Created">
              Check Materials &nbsp; <img src="../../../../assets/images/whiteCheck.png" style="margin-bottom: 2px;"/>
          </button>
  
          <!-- Checked Screen Button -->
          <button (click)="DeclineRequest(this.viewData)" class="button" type="button" style="background-color: #fff;color:#DA291C;border:1px solid #DA291C;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Checked">
            Decline &nbsp; <img src="../../../../assets/images/redCross.png" style="margin-bottom: 2px;"/>
          </button>
          <!-- <button class="button" type="button" style="background-color: #fff;color:#007CB0;border:1px solid #007CB0;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Checked">
            Resend Mail &nbsp; <img src="../../../../assets/images/blueEmail.png" style="margin-bottom: 2px;"/>
          </button> -->
          <button class="button blue" (click)="CollectMaterials(this.viewData)" type="button" style="background-color: #007CB0;border-width: 0px;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Checked">
              Collect Materials &nbsp; <img src="../../../../assets/images/whiteCheck.png" style="margin-bottom: 2px;"/>
          </button>

          <!-- Material Collected by Receipient Buttons -->
          <!-- <button class="button" type="button" style="background-color: #fff;color:#007CB0;border:1px solid #007CB0;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Collected">
            Resend Mail &nbsp; <img src="../../../../assets/images/blueEmail.png" style="margin-bottom: 2px;"/>
          </button> -->
          <button class="button blue" (click)="UploadChallan(this.viewData)" type="button" style="background-color: #007CB0;border-width: 0px;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.Collected">
              Upload Challan &nbsp; <img src="../../../../assets/images/whiteDownload.png" style="margin-bottom: 2px;"/>
          </button>
  
          <!-- Challan Uploaded Button -->
          <!-- <button class="button" type="button" style="background-color: #fff;color:#007CB0;border:1px solid #007CB0;border-radius: 0px;" *ngIf="this.viewData.statusId == InwardStatus.ChallanUploaded">
            Upload Challan &nbsp; <img src="../../../../assets/images/blueDownload.png" style="margin-bottom: 2px;"/>
          </button> -->
          <button (click)="ReceivedBy(this.viewData)" class="button blue" type="button" style="background-color: #007CB0;border-width: 0px;border-radius: 0px;" *ngIf="this.viewData.registrationType != InwardStatus.NonReturnable && this.viewData.statusId == InwardStatus.ChallanUploaded">
              Mark as Received &nbsp; <img src="../../../../assets/images/whiteExit.png" style="margin-bottom: 2px;"/>
          </button>
  
      </div>
    </div>
  </div>
  <form #inwardregform="ngForm">
    <div id="accordion" class="accordion">
        <div class="card">
            <div id="headingOne" class="card-header bg-white border-0">
                  <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="d-block position-relative collapsible-link py-2">
                    <app-inward-progress-bar></app-inward-progress-bar>
                    <br *ngIf="this.viewData.declinedByNotes != null && this.viewData.statusId==InwardStatus.Declined"/>
                    <div class="declined" *ngIf="this.viewData.declinedByNotes != null && this.viewData.statusId==InwardStatus.Declined">
                      <span>Declined Reason</span>
                      {{this.viewData.declinedByNotes}}
                    </div>
                  </div>
            </div>
            <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion" class="collapse show">
                <div class="card-body">
                  <!-- For Returnable -->
                  <div [ngClass]="{'angry-grid-declined':this.viewData.remarks!=null,'angry-grid1':this.viewData.remarks == null}" *ngIf="this.viewData.registrationType != InwardStatus.NonReturnable">
                    <div id="item-0">
                      <span>S.No.</span>
                      {{this.viewData.serialNumber}}
                    </div>
                    <div id="item-1">
                      <span>DC No/Tax invoice</span>
                      {{this.viewData.dcNumber}}
                    </div>
                    <div id="item-2">
                      <span>Request Type</span>
                      {{this.viewData.type}}
                    </div>
                    <div id="item-3">
                      <span>Registration Date</span>
                      {{this.viewData.registrationDateTime | date:'d MMM y'}}
                    </div>
                    <div id="item-4">
                      <span>Registration Time</span>
                      {{this.viewData.registrationDateTime | date:'h:mm a'}}
                    </div>
                    <div id="item-5">
                      <span>Due Date</span>
                      {{this.viewData.registrationType == InwardStatus.NonReturnable ? '-' : this.viewData.returnDateTime | date:'d MMM y'}}
                    </div>
                    <div id="item-6">
                      <span>Due Time</span>
                      {{this.viewData.registrationType == InwardStatus.NonReturnable ? '-' : this.viewData.returnDateTime | date:'h:mm a'}}
                    </div>
                    <div id="item-7">
                      <span>Brought From</span>
                      {{this.viewData.broughtFromName}}
                    </div>
                    <!-- <div id="item-8">
                      <span>Received By</span>
                      {{this.viewData.statusId==InwardStatus.Received ? this.viewData.receivedByName : '-'}}
                    </div> -->
                    <!-- <div id="item-9">
                      <span>Received On</span>
                      {{this.viewData.statusId == InwardStatus.Received ? (this.viewData.receivedOn | date:'d MMM y, h:mm a') : '-'}}
                    </div> -->
                    <div id="item-8"> <!-- 17-->
                      <span>Receipient's Name</span>
                      {{this.viewData.recipientName == null ? '-' : this.viewData.recipientName}}
                    </div>
                    <div id="item-9"> <!--18-->
                      <span>City</span>
                      {{this.viewData.cityName == null ? '-' : this.viewData.cityName}}
                    </div>
                    <div id="item-19" >
                      <span>Office</span>
                      {{this.viewData.officeName == null ? '-' : this.viewData.officeName}}
                    </div>
                    <div id="item-20" 
                    *ngIf="this.viewData.statusId == InwardStatus.Collected  || this.viewData.statusId == InwardStatus.ChallanUploaded  ||  this.viewData.statusId == InwardStatus.Received">
                      <span>Collected By</span>
                      {{this.viewData.collectedByName == null ? '-' : this.viewData.collectedByName}}
                    </div>
                    <div id="item-A" *ngIf="this.viewData.remarks != null">
                      <span>Remarks</span>
                      <div class="remarks-scroll">{{this.viewData.remarks}}</div>
                    </div>
                  </div>

                  <!-- For Non Returnable -->
                  <div [ngClass]="{'angry-grid-declined2':this.viewData.remarks!=null,'angry-grid2':this.viewData.remarks == null}" *ngIf="this.viewData.registrationType == InwardStatus.NonReturnable">
                    <div id="item-10">
                      <span>S.No.</span>
                      {{this.viewData.serialNumber}}
                    </div>
                    <div id="item-11">
                      <span>DC No/Tax invoice</span>
                      {{this.viewData.dcNumber}}
                    </div>
                    <div id="item-12">
                      <span>Request Type</span>
                      {{this.viewData.type}}
                    </div>
                    <div id="item-13">
                      <span>Registration Date</span>
                      {{this.viewData.registrationDateTime | date:'d MMM y'}}
                    </div>
                    <div id="item-14">
                      <span>Registration Time</span>
                      {{this.viewData.registrationDateTime | date:'h:mm a'}}
                    </div>
                    <div id="item-15">
                      <span>Brought From</span>
                      {{this.viewData.broughtFromName}}
                    </div>
                    <div id="item-16">
                      <span>Receipient's Name</span>
                      {{this.viewData.recipientName == null ? '-' : this.viewData.recipientName}}
                    </div>
                    <div id="item-21">
                      <span>City</span>
                      {{this.viewData.cityName == null ? '-' : this.viewData.cityName}}
                    </div>
                    <div id="item-22">
                      <span>Office</span>
                      {{this.viewData.officeName == null ? '-' : this.viewData.officeName}}
                    </div>
                    <div id="item-23" *ngIf="(this.viewData.statusId == InwardStatus.Collected || this.viewData.statusId == InwardStatus.ChallanUploaded) && this.viewData.remarks == null">
                      <span>Collected By</span>
                      {{this.viewData.collectedByName == null ? '-' : this.viewData.collectedByName}}
                    </div>
                    <div id="item-24" *ngIf="(this.viewData.statusId == InwardStatus.Collected || this.viewData.statusId == InwardStatus.ChallanUploaded) && this.viewData.remarks != null">
                      <span>Collected By</span>
                      {{this.viewData.collectedByName == null ? '-' : this.viewData.collectedByName}}
                    </div> 
                    <div id="item-B" *ngIf="this.viewData.remarks != null">
                      <span>Remarks</span>
                      <div class="remarks-scroll">{{this.viewData.remarks}}</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </form>
  
    <!-- Materials DropDown -->
    <!-- <div id="headingOne" class="card-header bg-white border-0">
      <h4 class="mb-0 font-weight-bold"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" class="d-block position-relative text-dark py-2">Materials</span></h4>
    </div> -->
    <div class="mt-1">
      <div class="col-md-3,attchmentTable" style="margin-top: 10px; width: 1000px" >
        <div *ngIf="attachedFiles.length > 0">
        <h3>Attached Files:</h3>
      </div>
        <ul>
          <li *ngFor="let file of this.viewData.attachedFiles; let i = index">
            {{ file.name }}           
            <img *ngIf="this.viewData.statusId == InwardStatus.Collected || this.viewData.statusId == InwardStatus.ChallanUploaded || this.viewData.statusId == InwardStatus.Received"  src="assets/images/download.png" alt="Delete" width="16" height="16" (click)="downloadFile(i)" style="cursor: pointer;margin-left: 20px;">             
            <img src="assets/images/view1.png" *ngIf="this.viewData.statusId===InwardStatus.Created || this.viewData.statusId===InwardStatus.Checked" alt="Delete" width="20" height="20" (click)="viewFile(i)" 
            style="cursor: pointer;margin-left: 20px;"> 
          </li>
        </ul>
      </div>
      <div class="row" style="margin-top:30px;margin-left: 10px;margin-right:10px">
        <div class="col-md-3" style="margin:auto">
          <h3>Materials</h3>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
          <div class="form-group has-search">
            <span class="icon-ic_search form-control-search"></span>
            <input class="form-control frontIcon searchtext" [(ngModel)]="searchText" #searchMat id="searchMat" autocomplete="off" placeholder="Search by description">
          </div>
        </div>
    </div>
    
    </div>
  
    <!-- Table Material -->
    <div class="card" style="margin-top: 10px;margin-bottom: 80px;margin-left:10px;margin-right:10px;border: 0px;" *ngIf="this.viewData.materialList.length > 0">
      <div [ngClass]="{'scrollable':(this.viewData.materialList.length > 5 && this.searchText.length == 0)}"> 
        <table class="demTable">
          <thead>
            <tr>
              <th>S.No.</th>
              <th width="20%">Description</th>
              <th>Required Quantity</th>
              <th width="50%">Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" *ngFor="let material of viewData.materialList | filter : searchText;let i=index">
              <td>&nbsp;<span style="margin-left:5px;">{{i+1}}</span></td>
              <td>
                <div class="BoxOne">
                  <span style="margin-left:8px;">{{material.name}}</span>
                </div>
              </td>
              <td>
                <div class="BoxOne">
                  <span style="margin-left:7px;">{{material.quantity}}</span>
                </div>
              </td>
              <td>
                <div class="BoxOne">
                  <span style="margin-left:7px;">{{material.notes == '' ? '-' : material.notes}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  
    <!-- Footer -->
  <footer class="page-footer" style="border-top: 1px solid #D0D0CE;" *ngIf="this.viewData.statusId == InwardStatus.Created">
  <button type="button" (click)="deleteReg(this.viewData.requestId,this.viewData.type,this.viewData)" style="background-color:#fff;border: 1px solid #DA291C;color:#DA291C;position: absolute;left: 25px;border-radius: 0;">Delete</button>
  <button type="button" (click)="editReg()" style="background: #007CB0;"><span>Edit</span></button>
  </footer>
  <!-- Footer -->
</div>
